const displayName = 'Kunder'
const appName     = 'clients'

export { displayName, appName }
